import $ from 'jquery';
import {toCurrency, updatePrices} from "../utilities";
import { basketUpdate } from "../queries";

$(document).on('mouseenter', '.header-basket', function () {
    if (window.innerWidth >= 1000) {
        $(this).addClass('header-basket--opened').addClass('header-basket--hovered');
    }
});

$(document).on('mouseleave', '.header-basket', function () {
    $(this).removeClass('header-basket--opened').removeClass('header-basket--hovered');
});

$(document).on('click', '.header-basket__control', function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = $(this).attr('href');
});

$(document).on('click', function () {
    $('.header-basket').removeClass('header-basket--opened');
});

$(document).on('click', '.header-basket__close', function () {
    $('.header-basket').removeClass('header-basket--opened');
});

$(document).on('click', '.header-basket__outer', function (e) {
    e.stopPropagation();
});
const basketUpdateDebounced = async (productId, quantity) => {
    let isMobile = false;
    if (window.innerWidth <= 768) {
        isMobile = true
    }

    const response = await basketUpdate(productId, quantity, isMobile);
    const wasOpened = $('.header-basket').hasClass('header-basket--opened');
    if (window.innerWidth <= 768) {
        $('.header-basket--mobile').replaceWith(response.component);
    }else{
        $('.header-basket').replaceWith(response.component);
    }

    if (wasOpened) {
        $('.header-basket').addClass('header-basket--opened');
    }
    setTimeout(() => {
        if (!$('.header-basket').hasClass('header-basket--hovered')) {
            $('.header-basket').removeClass('header-basket--opened');
        }
    }, 2000);
    updatePrices();
};
$(document).on('click', '.header-basket-item__delete', function (e) {
    e.stopPropagation();
    const $component = $(this).parents('.header-basket');
    const $item = $(this).parents('.header-basket-item');

    const productId = $item.attr('data-product-id');

    $item.remove();

    $component.trigger('calculate');

    $(`.age[data-id="${productId}"]`).removeClass('ui-product--basket');
    $('.catalog-detail-info').removeClass('catalog-detail-info--basket');
    // basketUpdate(productId, 0);
    basketUpdateDebounced(productId, 0);
});

$(document).on('calculate', '.header-basket', function () {
    $(this).find('.ui-scroll').trigger('init');
    let quantity = 0;
    $('.page-basket__content .ui-product-quantity[data-quantity]').map(function(){
        quantity += Number($(this).attr('data-quantity')) + 1
    });
    $('.header-basket__total, .header-basket__discount').hide();

    let totalPrice = 0;
    let totalDiscount = 0;

    $(this).find('.ui-value--product-price').each(function () {
        const quantity = +$(this).parents('.header-basket-item').attr('data-quantity');
        const price = $(this).attr('data-price');
        const discount = $(this).attr('data-discount');
        if (price) {
            totalPrice += +price * quantity;
        }
        if (discount) {
            totalDiscount += +discount * quantity;
        }
        if (!price) {
            $(this).text('Нет в наличии').show();
        }
    });

    if (totalPrice > 0) {
        $('.header-basket__total span').text(toCurrency(totalPrice)).show();
        $('.header-basket__total').show();
        if (totalDiscount > 0) {
            $('.header-basket__discount span').text(toCurrency(totalDiscount)).show();
            $('.header-basket__discount').show();
        }
    }
});

$(document).on('prices-updated', function () {
    $('.header-basket').trigger('calculate');
});
